import React from 'react'
import classnames from 'classnames';
import PropTypes from 'prop-types'
import './Badges.scss'
import HrbTranslate from '../../language/HrbTranslate';

const QueueStatusBadge = props => {

    const { textKey, status, className } = props

    return (
        <div className={classnames('queue', className)}>
            <HrbTranslate text={textKey} />
        </div>)
}

QueueStatusBadge.propTypes = {
    textKey: PropTypes.string.isRequired,
    status: PropTypes.string.isRequired,
    className: PropTypes.string
}

export default QueueStatusBadge